import { createFileRoute } from '@tanstack/react-router';
import LoadingPage from '../../../../../components/shared/page-components/LoadingPage';
import WalletPage from '../../../../../components/source-management/wallets/wallet-page/WalletPage';

export const Route = createFileRoute(
  '/_authenticated/(sources)/wallets/$walletId/_wallet',
)({
  component: WalletPage,
  pendingComponent: () => <LoadingPage loadingPage />,
  staticData: {
    meta: {
      title: 'Wallet Details | Ledgible',
    },
  },
});
